import React from 'react';
import { Card, Alert } from '@/components/ui';

// Credit Card Icon
const CreditCardIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className || 'w-6 h-6'}
  >
    <path d="M4.5 3.75a3 3 0 00-3 3v.75h21v-.75a3 3 0 00-3-3h-15z" />
    <path
      fillRule="evenodd"
      d="M1.5 9.75v7.5a3 3 0 003 3h15a3 3 0 003-3v-7.5h-21zM6 13.5a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75H6.75a.75.75 0 01-.75-.75V13.5zm3.75-.75a.75.75 0 00-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 00.75-.75V13.5a.75.75 0 00-.75-.75H9.75z"
      clipRule="evenodd"
    />
  </svg>
);

export const BillingSection: React.FC = () => {
  return (
    <Card padding="lg">
      <div className="flex items-center mb-6">
        <CreditCardIcon className="w-6 h-6 mr-3 text-primary-600" />
        <h2 className="text-xl font-semibold text-secondary-900">
          Billing & Subscriptions
        </h2>
      </div>

      <div className="py-12 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary-100 mb-4">
          <CreditCardIcon className="w-8 h-8 text-primary-600" />
        </div>

        <h3 className="text-lg font-medium text-secondary-900 mb-2">
          Coming Soon
        </h3>
        <p className="text-secondary-600 max-w-md mx-auto mb-6">
          Subscription management and billing features are currently in
          development. This section will allow you to manage organization
          subscriptions, view invoices, and update payment methods.
        </p>

        <Alert variant="info" className="max-w-md mx-auto">
          <p className="text-sm">
            <strong>Current Status:</strong> All organizations are on the FREE
            tier during the beta period. Enterprise customers can contact
            support for custom arrangements.
          </p>
        </Alert>
      </div>

      <div className="border-t border-secondary-200 pt-6 mt-6">
        <h4 className="text-sm font-medium text-secondary-700 mb-3">
          Planned Features
        </h4>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm text-secondary-600">
          <li className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-secondary-400 rounded-full" />
            Subscription tier management
          </li>
          <li className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-secondary-400 rounded-full" />
            Usage-based billing reports
          </li>
          <li className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-secondary-400 rounded-full" />
            Invoice history and downloads
          </li>
          <li className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-secondary-400 rounded-full" />
            Payment method management
          </li>
          <li className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-secondary-400 rounded-full" />
            Spending alerts and limits
          </li>
          <li className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-secondary-400 rounded-full" />
            Enterprise contract management
          </li>
        </ul>
      </div>
    </Card>
  );
};

export default BillingSection;
